import script from "./region.vue?vue&type=script&setup=true&lang=js"
export * from "./region.vue?vue&type=script&setup=true&lang=js"

import "./region.vue?vue&type=style&index=0&id=393b8b2a&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393b8b2a"]])

export default __exports__